'use strict';
import React from 'react';
import condoSetAction from '../../actions/condoSetAction';

class CondoCheckListForm extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }
    handleChange(e) {
        let checkListId = e.target.value;
        let checked = e.target.checked;
        let condo = this.props.condo;
        if (checked) {
            condo.checkList.push(checkListId);
        } else {
            //remove checklist
            let len = condo.checkList.length;
            for (let i = 0; i < len; i++) {
                if (condo.checkList[i] == checkListId) {
                    condo.checkList.splice(i, 1);
                    break;
                }
            }

            if (typeof condo.categories != "undefined") {
                let i = 0;
                while (i < condo.categories.length) {
                    if (condo.categories[i].facilityId == checkListId) {
                        condo.categories.splice(i, 1);
                    } else {
                        i++;
                    }
                }
            }
        }
        condoSetAction.condo(condo);
    }
    handleCategory = (facilityId) => (e) => {
        let category = e.target.value;
        let checked = e.target.checked;
        let condo = this.props.condo;
        if (typeof condo.categories == "undefined") {
            condo.categories = [];
        }

        if (checked) {
            condo.categories.push({ facilityId: facilityId, category: category });
        } else {
            let len = condo.categories.length;
            for (let i = 0; i < len; i++) {
                if (condo.categories[i].facilityId == facilityId && condo.categories[i].category == category) {
                    condo.categories.splice(i, 1);
                    break;
                }
            }
        }
        condoSetAction.condo(condo);

    }
    handleClick(e) {

        let condo = this.props.condo;
        let s = this.props.checkList
        if (condo.checkList.length != s.length) {
            //check all
            condo.checkList = [];
            condo.categories = [];
            for (let i = 0; i < s.length; i++) {
                condo.checkList = condo.checkList.concat(s[i]._id);
                if (typeof s[i].categories != 'undefined') {
                    s[i].categories.forEach((category) => {
                        condo.categories = condo.categories.concat({
                            facilityId: s[i]._id, category: category.category
                        });
                    });
                }
            }
        } else {
            condo.checkList = [];
            condo.categories = [];
        }
        condoSetAction.condo(condo);
    }
    checkFacility(checkList) {
        let isCheck = false;
        let condoLen = this.props.condo.checkList.length;
        for (let i = 0; i < condoLen; i++) {
            if (this.props.condo.checkList[i] == checkList._id) {
                isCheck = true;
                break;
            }
        }
        return isCheck;
    }

    renderFacility(checkList, index) {
        //check if this facility is included;
        let isCheck = this.checkFacility(checkList);

        return (
            <div key={index}>
                <li className="cl-li-1" >
                    <div className="checkbox">
                        <label>
                            <input type="checkbox" value={checkList._id} onChange={this.handleChange} checked={isCheck} />
                            <span className="checkmark"></span>
                            {checkList.facility}
                        </label>
                    </div>
                </li>
                {this.renderCategory(checkList.categories, checkList._id)}
            </div>
        )
    }
    checkCategory(facilityId, category) {
        let categories = this.props.condo.categories;
        if (typeof categories == "undefined") return false;

        if (categories != null && categories != "") {
            for (let i = 0; i < categories.length; i++) {
                if (categories[i].facilityId == facilityId && categories[i].category == category) {
                    return true;
                }
            }
        }
        return false;
    }
    renderCategory = (categories, facilityId) => {
        if (!categories) return "";
        return categories.map((ct, index) => {
            let isCheck = this.checkCategory(facilityId, ct.category);
            return (
                <li key={index} className="cl-li-2" >
                    <div className="checkbox">
                        <label>
                            <input type="checkbox" value={ct.category} onChange={this.handleCategory(facilityId)} checked={isCheck} />
                            <span className="checkmark"></span>
                            {ct.category}
                        </label>
                    </div>
                </li>
            );
        });
    }
    renderCheckList() {
        let s = this.props.checkList
        let checkList = s.map((checkList, index) => {
            return this.renderFacility(checkList, index);
        });

        return (
            <ul className="cl-fc" >
                {checkList}
            </ul>
        )
    }
    render() {
        return (
            <div>
                <h4><b>Check List</b></h4>
                <button className="btn btn-default btn-sm cl-btn-1" onClick={this.handleClick}>Select/Deselect All</button>
                {this.renderCheckList()}
            </div>
        );
    }
}
export default CondoCheckListForm;


// WEBPACK FOOTER //
// ./app/setComponents/condoSetComponents/condoCheckListForm.js